import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "./cn.js";
export function Menu({ label, role = "menu", className, ...rest }) {
    return _jsx("div", { className: cn("fwfa-menu", className), role: role, "aria-label": label, ...rest });
}
export function MenuItem({ selected, meta, role, className, children, ...rest }) {
    return (_jsxs("button", { type: "button", className: cn("fwfa-menu-item", className), role: role ?? (selected !== undefined ? "menuitemradio" : "menuitem"), "aria-checked": selected !== undefined ? selected : undefined, ...rest, children: [children, meta !== undefined && _jsx("span", { className: "fwfa-menu-item-meta", children: meta })] }));
}
export function MenuSeparator({ className, ...rest }) {
    return _jsx("div", { className: cn("fwfa-menu-separator", className), role: "separator", ...rest });
}
//# sourceMappingURL=Menu.js.map